module.exports = __webpack_public_path__ + "static/media/truck11.afa8c614.jpg";